/* Native Shopify newsletter popup. No email address is stored in the browser. */
(function () {
  'use strict';
  if (window.__dstEmailPopupRuntime) return;
  window.__dstEmailPopupRuntime = true;
  var lastInteraction = 0;
  ["pointerdown", "keydown", "change", "submit"].forEach(function (name) { document.addEventListener(name, function () { lastInteraction = Date.now(); }, true); });
  var KEY = 'dst_email_popup_seen', SUCCESS = 'dst_email_popup_success';
  function read(key) { try { return Number(localStorage.getItem(key)) || 0; } catch (e) { return 0; } }
  function write(key) { try { localStorage.setItem(key, String(Date.now())); } catch (e) {} }
  // Only real text entry counts as typing; a focused radio, checkbox or button (e.g. a size swatch) does not.
  function typing() {
    var el = document.activeElement; if (!el) return false;
    if (el.isContentEditable || el.tagName === 'TEXTAREA' || el.tagName === 'SELECT') return true;
    if (el.tagName !== 'INPUT') return false;
    return !/^(radio|checkbox|button|submit|reset|image|range|color|file|hidden)$/i.test(el.type || 'text');
  }
  function privacyBannerVisible() {
    return Array.prototype.some.call(document.querySelectorAll('#shopify-pc__banner, .shopify-pc__banner__dialog, [data-privacy-banner]'), function (el) {
      return !el.hidden && el.getAttribute('aria-hidden') !== 'true' && el.getClientRects().length > 0;
    });
  }
  function mount(scope) {
    var root = scope && scope.matches && scope.matches('[data-email-popup]') ? scope : (scope || document).querySelector('[data-email-popup]');
    if (!root || root.__dstEmailPopup || !window.DST || !DST.dialog) return;
    var dlg = DST.dialog(root.id), timer = null, attempts = 0, disposed = false, ac = new AbortController();
    if (!dlg) return;
    var days = Math.max(1, Number(root.getAttribute('data-frequency')) || 14);
    var design = root.getAttribute('data-design-mode') === 'true';
    var ownResult = /EmailPopupForm/.test(window.location.hash) && root.querySelector('[data-popup-result]');
    function eligible() {
      return !read(SUCCESS) && Date.now() - read(KEY) >= days * 86400000;
    }
    function show(preview) {
      preview = preview === true && design;
      if (disposed || !document.contains(root)) return;
      if (!preview && (Date.now() - lastInteraction < 10000 || document.querySelector('[aria-busy="true"]') || document.hidden || privacyBannerVisible() || document.querySelector('.dialog.is-open') || typing())) {
        if (++attempts < 120) timer = setTimeout(show, 1000);
        return;
      }
      if (!preview && !ownResult && !eligible()) return;
      dlg.open(document.activeElement);
      if (!design && !ownResult) write(KEY);
      ownResult = null;
    }
    root.addEventListener('dialog:close', function () { if (!design) write(KEY); }, { signal: ac.signal });
    root.__dstEmailPopup = {
      destroy: function () {
        disposed = true; clearTimeout(timer); ac.abort(); dlg.close(); clearTimeout(dlg.hideTimer);
        if (DST.dialogs && DST.dialogs[root.id] === dlg) delete DST.dialogs[root.id];
        root.__dstEmailPopup = null;
      },
      preview: function () { show(true); }
    };
    if (ownResult) {
      if (ownResult.getAttribute('data-popup-result') === 'success') write(SUCCESS);
      timer = setTimeout(show, 0);
    } else if (!design && eligible()) timer = setTimeout(show, Math.max(10, Number(root.getAttribute('data-delay')) || 20) * 1000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { mount(document); });
  else mount(document);
  document.addEventListener('shopify:section:load', function (e) { mount(e.target); });
  document.addEventListener('shopify:section:select', function (e) {
    var root = e.target.querySelector('[data-email-popup]');
    if (root && root.__dstEmailPopup) root.__dstEmailPopup.preview();
  });
  document.addEventListener('shopify:section:unload', function (e) {
    var root = e.target.querySelector('[data-email-popup]');
    if (root && root.__dstEmailPopup) root.__dstEmailPopup.destroy();
  });
})();
